"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLayout = exports.reorganize_node_outputLinksId = exports.reorganize_node_inputLinksId = exports.reorganize_inputLinksId = exports.reorganize_all_input_outputLinksId = exports.explore_branch = exports.desagregation = exports.compute_default_input_outputLinksId = exports.compute_auto_sankey = exports.arrangeNodes = exports.apply_input_outputLinksId = exports.agregation = exports.AgregationModal = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _types = require("./types");

var _SankeyConvert = require("./SankeyConvert");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var reorganize_node_inputLinksId = function reorganize_node_inputLinksId(node, nodes, links) {
  var input_links = Object.values(links).filter(function (l) {
    return l.idTarget === node.idNode;
  });
  input_links.sort(function (l1, l2) {
    var n1Id = l1.idSource;
    var n2Id = l2.idSource;

    if (n1Id !== n2Id) {
      var n1 = nodes[n1Id];
      var n2 = nodes[n2Id];

      if (n1 && n2 && n1.y < n2.y) {
        return -1;
      }

      return 1;
    } else {
      var _n = nodes[n1Id];

      if (_n) {
        var output_l1_index = _n.outputLinksId.indexOf(l1.idLink);

        var output_l2_index = _n.outputLinksId.indexOf(l2.idLink);

        var l1_index = input_links.indexOf(l1);
        var l2_index = input_links.indexOf(l1);

        if (output_l1_index < output_l2_index && l1_index < l2_index || output_l1_index > output_l2_index && l1_index > l2_index) {
          return 1;
        }

        return -1;
      } else {
        return 1;
      }
    }
  });
  node.inputLinksId = input_links.map(function (l) {
    return l.idLink;
  });
};

exports.reorganize_node_inputLinksId = reorganize_node_inputLinksId;

var reorganize_node_outputLinksId = function reorganize_node_outputLinksId(node, nodes, links) {
  var output_links = Object.values(links).filter(function (l) {
    return l.idSource === node.idNode;
  });
  output_links.sort(function (l1, l2) {
    var n1Id = l1.idTarget;
    var n2Id = l2.idTarget;

    if (n1Id !== n2Id) {
      var n1 = nodes[n1Id];
      var n2 = nodes[n2Id];

      if (n1 && n2 && n1.y < n2.y) {
        return -1;
      }

      return 1;
    } else {
      var _n2 = nodes[n1Id];

      if (_n2) {
        var input_l1_index = _n2.inputLinksId.indexOf(l1.idLink);

        var input_l2_index = _n2.inputLinksId.indexOf(l2.idLink);

        var l1_index = output_links.indexOf(l1);
        var l2_index = output_links.indexOf(l1);

        if (input_l1_index < input_l2_index && l1_index < l2_index || input_l1_index > input_l2_index && l1_index > l2_index) {
          return 1;
        }

        return -1;
      } else {
        return 1;
      }
    }
  });
  node.outputLinksId = output_links.map(function (l) {
    return l.idLink;
  });
};

exports.reorganize_node_outputLinksId = reorganize_node_outputLinksId;

var reorganize_inputLinksId = function reorganize_inputLinksId(node, input, output, nodes, links) {
  //const node = nodes[node_id]
  if (input) {
    reorganize_node_inputLinksId(node, nodes, links);
  }

  if (output) {
    reorganize_node_outputLinksId(node, nodes, links);
  }
};

exports.reorganize_inputLinksId = reorganize_inputLinksId;

var compute_default_input_outputLinksId = function compute_default_input_outputLinksId(nodes, links) {
  Object.values(nodes).forEach(function (n) {
    n.inputLinksId = [];
    n.outputLinksId = [];
  });
  Object.values(links).forEach(function (link) {
    nodes[link.idTarget].inputLinksId.push(link.idLink);
    nodes[link.idSource].outputLinksId.push(link.idLink);
  });
};

exports.compute_default_input_outputLinksId = compute_default_input_outputLinksId;

var normalize_name = function normalize_name(name) {
  var new_name = name.split('\\n').join('').split(' ').join('');
  return new_name;
};

var apply_input_outputLinksId = function apply_input_outputLinksId(ref_nodes, ref_links, data) {
  var display_nodes = data.nodes;
  var display_links = data.links;
  Object.values(ref_nodes).forEach(function (ref_node) {
    var node = display_nodes[ref_node.idNode];

    if (node === undefined) {
      return;
    }

    var new_inputLinksId = [];
    ref_node.inputLinksId.forEach(function (idLink) {
      var ref_link = ref_links[idLink];

      if (ref_link === undefined) {
        return;
      }

      var links = Object.values(display_links).filter(function (l) {
        return normalize_name(data.nodes[l.idSource].name) === normalize_name(ref_nodes[ref_link.idSource].name) && normalize_name(data.nodes[l.idTarget].name) === normalize_name(ref_nodes[ref_link.idTarget].name);
      });

      if (links.length === 0) {
        return;
      } //node.inputLinksId.splice(node.inputLinksId.indexOf(link.idLink),1)


      new_inputLinksId.push(links[0].idLink);
    }); //const result_inputLinksId = node.inputLinksId.concat(new_inputLinksId)

    node.inputLinksId = new_inputLinksId; //result_inputLinksId.filter(function (item, pos) {return node.inputLinksId.indexOf(item) == pos})

    var new_outputLinksId = [];
    ref_node.outputLinksId.forEach(function (idLink) {
      var ref_link = ref_links[idLink];

      if (ref_link === undefined) {
        return;
      }

      var links = Object.values(display_links).filter(function (l) {
        return normalize_name(data.nodes[l.idSource].name) === normalize_name(ref_nodes[ref_link.idSource].name) && normalize_name(data.nodes[l.idTarget].name) === normalize_name(ref_nodes[ref_link.idTarget].name);
      });

      if (links.length === 0) {
        return;
      } //node.outputLinksId.splice(node.outputLinksId.indexOf(link.idLink),1)


      new_outputLinksId.push(links[0].idLink);
    }); //const result_outputLinksId = node.outputLinksId.concat(new_outputLinksId)

    node.outputLinksId = new_outputLinksId; //result_outputLinksId.filter(function (item, pos) {return node.outputLinksId.indexOf(item) == pos})
  });
};

exports.apply_input_outputLinksId = apply_input_outputLinksId;

var explore_branch = function explore_branch(idNode, current_length, visited_nodes, links, nodes) {
  var no_input_link = true;
  var highest_branch_length = current_length;
  Object.values(links).forEach(function (link) {
    if (link.idTarget === idNode && nodes[link.idSource].node_visible) {
      // if the node has never been visited, continue to explore the branch, otherwise stop (for recycling flows).
      if (visited_nodes.indexOf(idNode) === -1) {
        no_input_link = false;
        var branch_length = explore_branch(link.idSource, current_length + 1, [].concat((0, _toConsumableArray2.default)(visited_nodes), [idNode]), links, nodes);

        if (branch_length > highest_branch_length) {
          highest_branch_length = branch_length;
        }
      }
    }
  });

  if (no_input_link === true) {
    return current_length;
  } else {
    return highest_branch_length;
  }
};

exports.explore_branch = explore_branch;

var arrangeNodes = function arrangeNodes(data, h_space, v_space) {
  // const display_nodes : SankeyNode[] = Object.values(data.nodes).filter( n=> n.display )
  Object.values(data.nodes).forEach(function (node) {
    if (!node.node_visible) {
      return;
    }

    var x = Math.round(node.x / h_space) * h_space;
    var y = Math.round(node.y / v_space) * v_space;
    node.x = x;
    node.y = y;
  });
};

exports.arrangeNodes = arrangeNodes;

var compute_auto_sankey = function compute_auto_sankey(data, h_space) {
  //let display_nodes : { [node_id : string]:SankeyNode} = Object.assign({}, ...Object.values(data.nodes).filter( n=> n.n ).map(n=> ({[n.idNode] : {...n} })))
  // const display_links : { [link_id : string]:SankeyLink}  = Object.assign({}, ...Object.values(data.links).filter( l=> {
  //   const source_node = data.nodes[l.idSource]
  //   const target_node = data.nodes[l.idTarget]
  //   return source_node.display &&  target_node.display
  // }).map(l=> ({[l.idLink] : {...l} })))
  //const extended_links = display_links as (SankeyLink & ExtendedSankeyLink)[]
  //sankey.update_scale(data.user_scale)
  // var alerte = false
  // var message = ''
  var max_node_value = 0; // Horizontal position of vertical nodes

  var max_horizontal_index = 0; // var list_of_x_before : number[] = []
  // var list_of_x_after : number[] = []
  // var the_nodes_min : SankeyNode[] = []
  // var the_nodes_max : SankeyNode[] = []  
  // var default_node_size = sankey.get_default_node_size() 
  // if (!positions) {
  //   return
  // }
  // Use a relevant scale

  Object.values(data.links).forEach(function (link) {
    return link.value.forEach(function (v) {
      return max_node_value = v > max_node_value ? v : max_node_value;
    });
  });
  data.user_scale = max_node_value;
  var vspace = data.v_space;
  var horizontal_indices = {};
  Object.values(data.nodes).filter(function (n) {
    return n.node_visible;
  }).forEach(function (node) {
    var horizontal_index = explore_branch(node.idNode, 0, [], data.links, data.nodes);
    horizontal_indices[node.idNode] = horizontal_index;

    if (horizontal_index > max_horizontal_index) {
      max_horizontal_index = horizontal_index;
    }
  });
  Object.values(data.links).filter(function (l) {
    return data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible;
  }).forEach(function (l) {
    if (horizontal_indices[l.idSource] >= horizontal_indices[l.idTarget]) {
      l.recycling = true;
    }
  });
  var width = max_horizontal_index * h_space;
  Object.values(data.nodes).forEach(function (node) {
    if (!node.node_visible) {
      return;
    }

    node.x = 50 + horizontal_indices[node.idNode] / max_horizontal_index * width; //* 0.9
  }); // Reorder links using the x of source name as criteria 
  // Compute input_outputLinksId

  Object.values(data.nodes).filter(function (n) {
    return n.node_visible;
  }).forEach(function (n) {
    return data.nodes[n.idNode] = (0, _objectSpread2.default)({}, n);
  });
  compute_default_input_outputLinksId(data.nodes, data.links); // Vertical position of vertical nodes
  // compute total height of nodes that belong to the same column, then compute the spaces between them and their positions.

  var max_vertical_offset = 0;

  var _loop = function _loop(i) {
    var vertical_space = void 0;
    var vertical_offset = 0;
    var the_nodes = Object.values(data.nodes).filter(function (n) {
      return n.node_visible && horizontal_indices[n.idNode] === i;
    });

    if (the_nodes.length > 1) {
      //vertical_space = (0.6 * height - total_height) / (total_nb - 1)
      vertical_space = vspace; //(200 - total_height) / (total_nb - 1)
    } else {
      vertical_space = 0;
    }

    the_nodes.forEach(function (node, node_id) {
      var total_input_offset = 0;
      node.inputLinksId.forEach(function (idLink) {
        if (data.nodes[data.links[idLink].idSource].node_visible && data.nodes[data.links[idLink].idTarget].node_visible) {
          total_input_offset += +data.links[idLink].value[0];
        }
      });

      if (node_id === 0) {
        node.y = 200; //0.2 * height;

        vertical_offset = 200 + vertical_space;
      } else {
        node.y = vertical_offset;
        vertical_offset += vertical_space;
      }
    });

    if (max_vertical_offset < vertical_offset) {
      max_vertical_offset = vertical_offset;
    }
  };

  for (var i = 0; i <= max_horizontal_index; i++) {
    _loop(i);
  }

  var _loop2 = function _loop2(_i) {
    var the_nodes = Object.values(data.nodes).filter(function (n) {
      return n.node_visible && horizontal_indices[n.idNode] === _i;
    });
    var total_nb_outputLinksId_up = 0;
    var total_nb_outputLinksId_down = 0;
    the_nodes.forEach(function (node) {
      node.outputLinksId.forEach(function (idLink) {
        if (data.nodes[data.links[idLink].idSource].node_visible && data.nodes[data.links[idLink].idTarget].node_visible) {
          var target_node = data.nodes[data.links[idLink].idTarget];

          if (target_node === undefined) {
            console.log(data.links[idLink].idTarget);
            return;
          }

          if (target_node.y < node.y) {
            total_nb_outputLinksId_up += 1;
          } else {
            total_nb_outputLinksId_down += 1;
          }
        }
      });
    });
    var current_output_link_up = 0;
    var current_output_link_down = 0;
    the_nodes.forEach(function (node) {
      node.outputLinksId.forEach(function (idLink) {
        if (data.nodes[data.links[idLink].idSource].node_visible && data.nodes[data.links[idLink].idTarget].node_visible) {
          var target_node = data.nodes[data.links[idLink].idTarget];

          if (target_node === undefined) {
            console.log(data.links[idLink].idTarget);
            return;
          }

          if (target_node.y < node.y) {
            data.links[idLink].left_horiz_shift = data.left_shift + current_output_link_up / total_nb_outputLinksId_up * data.max_shift;
            data.links[idLink].right_horiz_shift = data.right_shift + current_output_link_up / total_nb_outputLinksId_up * data.max_shift;
            current_output_link_up += 1;
          } else {
            data.links[idLink].left_horiz_shift = data.left_shift - current_output_link_down / total_nb_outputLinksId_down * data.max_shift;
            data.links[idLink].right_horiz_shift = data.right_shift - current_output_link_down / total_nb_outputLinksId_down * data.max_shift;
            current_output_link_down += 1;
          }
        }
      });
    });
  };

  for (var _i = 0; _i <= max_horizontal_index; _i++) {
    _loop2(_i);
  } // Vertical position of horizontal nodes
  // nodes.forEach(node => {
  //   if (node.orientation === 'horizontal') {
  //     if (that.explore_branch(node.id,0,[node.id]) === 0,trade_sectors) {
  //       node.x = 50
  //       node.y = 100//0.05 * height;
  //     }
  //     else {
  //       node.y = max_vertical_offset//0.95 * height;
  //     }
  //   }
  // })
  // Horizontal position of horizontal nodes
  // associate position constraint to each horizontal node and order nodes by constraints   
  // nodes.forEach(node => {
  //   if (node.orientation === 'horizontal') {
  //     if (node.outputLinksId.length > 0) {
  //       var min_x = width
  //       node.outputLinksId.forEach(output_link=>{
  //         var output_node = nodes.filter(n=>n.idNode===output_link.idTarget)[0]
  //         if (output_node.x < min_x) {
  //           min_x = output_node.x
  //         }
  //       })
  //       node.x_before = min_x
  //       if (list_of_x_before.indexOf(min_x) === -1) {
  //         list_of_x_before.push(min_x)
  //         the_nodes_min[min_x] = []
  //       }
  //       the_nodes_min[min_x].push(node)
  //     }        
  //     else if (node.inputLinksId.length > 0) {
  //       var max_x = 0
  //       node.inputLinksId.forEach(input_link=>{
  //         var input_node = nodes.filter(n=>n.idNode===input_link.idSource)[0]
  //         if (nodes[input_node].x > max_x) {
  //           max_x = nodes[input_node].x
  //         }
  //       })
  //       node.x_after = max_x
  //       if (list_of_x_after.indexOf(max_x) === -1) {
  //         list_of_x_after.push(max_x)
  //         the_nodes_max[max_x] = []
  //       }
  //       the_nodes_max[max_x].push(node)
  //     }
  //   }
  // })
  // give x position to horiz nodes
  // list_of_x_before.forEach(x_before => {
  //   var horizontal_offset = x_before - 3 * default_node_size
  //   the_nodes_min[x_before].forEach(
  //     node => {
  //       let total_output_offset = 0
  //       node.outputLinksId.forEach(
  //         (id) => total_output_offset += +links[id].value
  //       )
  //       node.x = horizontal_offset - that.sankey.scale(total_output_offset)
  //       horizontal_offset -= that.sankey.scale(total_output_offset) + 3 * default_node_size
  //     }
  //   )
  // })    
  // list_of_x_after.forEach( x_after => {
  //   var horizontal_offset = x_after + 3 * default_node_size
  //   the_nodes_max[x_after].forEach(node => {
  //     let total_input_offset = 0
  //     node.inputLinksId.forEach(
  //       (id) => total_input_offset += +links[id].value
  //     )
  //     node.x = horizontal_offset
  //     horizontal_offset += that.sankey.scale(total_input_offset) + 3 * default_node_size
  //   })
  // })
  //data.max_vertical_offset = max_vertical_offset


  data.width = width + h_space; //data.height = Math.max(1500,max_vertical_offset + 100)

  reorganize_all_input_outputLinksId(data.nodes, data.links);
  return [];
};

exports.compute_auto_sankey = compute_auto_sankey;

var reorganize_all_input_outputLinksId = function reorganize_all_input_outputLinksId(nodes, links) {
  Object.values(nodes).forEach(function (node) {
    reorganize_node_inputLinksId(node, nodes, links);
    reorganize_node_outputLinksId(node, nodes, links);
  });
};

exports.reorganize_all_input_outputLinksId = reorganize_all_input_outputLinksId;

var updateLayout = function updateLayout(data, new_layout) {
  (0, _SankeyConvert.convert_data)(new_layout);
  var max_vertical_offset = 0;

  var compute_offset = function compute_offset(node) {
    if (!node.node_visible) {
      return;
    }

    max_vertical_offset = Math.max(node.y, max_vertical_offset);
  };

  Object.values(data.nodes).forEach(compute_offset);
  max_vertical_offset = max_vertical_offset + 200;
  data.node_width = new_layout.node_width; // Apply nodes layout

  var _loop3 = function _loop3(node_layout_key) {
    var node_layout = new_layout.nodes[node_layout_key];
    var nodes = Object.values(data.nodes).filter(function (n) {
      return normalize_name(n.name) === normalize_name(node_layout.name);
    });
    var node = void 0;

    if (nodes.length === 0) {
      if (node_layout.inputLinksId.length === 0 && node_layout.outputLinksId.length === 0 && node_layout.shape_visible === false && node_layout.label_visible === true) {
        // Case of not a label
        node = (0, _objectSpread2.default)({}, node_layout);
        node.idNode = 'node' + data.node_idx;
        data.node_idx = data.node_idx + 1;
        data.nodes[node.idNode];
      } else {
        return "continue";
      }
    }

    node = nodes[0];

    if (!node) {
      return "continue";
    } // if (!node.node_visible) {
    //   continue
    // }


    node.name = node_layout.name;
    node.x = node_layout.x;
    node.y = node_layout.y;

    if (node.y + 200 > max_vertical_offset) {
      max_vertical_offset = node.y + 200;
    } //node.color = node_layout.color


    node.x_label = node_layout.x_label;
    node.y_label = node_layout.y_label;
    node.label_visible = node_layout.label_visible;
  };

  for (var node_layout_key in new_layout.nodes) {
    var _ret = _loop3(node_layout_key);

    if (_ret === "continue") continue;
  } // apply_input_outputLinksId(
  //   new_layout.nodes,
  //   new_layout.links,
  //   data
  // )


  var _loop4 = function _loop4(link_layout_key) {
    var link_layout = new_layout.links[link_layout_key];
    var links = Object.values(data.links).filter(function (l) {
      return normalize_name(data.nodes[l.idSource].name) === normalize_name(new_layout.nodes[link_layout.idSource].name) && normalize_name(data.nodes[l.idTarget].name) === normalize_name(new_layout.nodes[link_layout.idTarget].name);
    });

    if (links.length === 0) {
      return "continue";
    }

    var link = links[0]; // if ( link_layout.display_value !== 'default' && 
    //     !String(link_layout.display_value).includes('[') ) {
    //   link.value = link_layout.value
    // }
    // const node_source = Object.values(data.nodes).filter( n => n.name ===new_layout.nodes[link_layout.idSource].name)
    // const node_target = Object.values(data.nodes).filter( n => n.name ===new_layout.nodes[link_layout.idTarget].name)
    // if (node_source && node_target) {
    //   link.idSource = node_source.idNode
    //   link.idSource = node_target.idNode
    // }

    var x_label = link_layout.x_label,
        y_label = link_layout.y_label,
        label_position = link_layout.label_position,
        label_visible = link_layout.label_visible,
        recycling = link_layout.recycling,
        curved = link_layout.curved,
        curvature = link_layout.curvature,
        arrow = link_layout.arrow,
        orthogonal_label_position = link_layout.orthogonal_label_position;
    link.curvature = curvature;
    link.curved = curved;
    link.arrow = arrow;
    link.text_color = link_layout.text_color;
    link.label_position = label_position;
    link.label_visible = label_visible;
    link.x_label = x_label;
    link.y_label = y_label;
    link.left_horiz_shift = link_layout.left_horiz_shift;
    link.right_horiz_shift = link_layout.right_horiz_shift;
    link.orientation = link_layout.orientation;
    link.recycling = recycling;
    link.orthogonal_label_position = orthogonal_label_position;

    if (String(link.display_value[0]).includes('*')) {
      link.value[0] = link_layout.value[0];
    }

    if (link_layout.vert_shift) {
      link.left_horiz_shift = link_layout.left_horiz_shift;
      link.right_horiz_shift = link_layout.right_horiz_shift;
      link.vert_shift = link_layout.vert_shift;
    }
  };

  for (var link_layout_key in new_layout.links) {
    var _ret2 = _loop4(link_layout_key);

    if (_ret2 === "continue") continue;
  } //data.animation_tooltips = new_layout.animation_tooltips


  data.user_scale = new_layout.user_scale;
  data.legend_position = new_layout.legend_position;
  data.welcome_text = new_layout.welcome_text; // if ('height' in new_layout) {
  //   data.height = new_layout.height
  // }

  if ('width' in new_layout) {
    data.width = new_layout.width;
  }

  Object.keys(new_layout.display_style).forEach(function (key) {
    return data.display_style[key] = new_layout.display_style[key];
  });

  if (data.display_style.filter === undefined) {
    data.display_style.filter = 0;
  }

  if (data.display_style.filter_label === undefined) {
    data.display_style.filter_label = 0;
  }
};

exports.updateLayout = updateLayout;

var desagregation = function desagregation(data, idChildNode, cur_dimension) {
  var idParent = data.nodes[idChildNode].dimensions[cur_dimension].parent_name;

  if (!idParent) {
    return;
  }

  var desagregate_nodes = Object.values(data.nodes).filter(function (n) {
    return n.dimensions[cur_dimension] && n.dimensions[cur_dimension].parent_name === idParent;
  });
  desagregate_nodes.forEach(function (n) {
    n.display = true;
    n.node_visible = true;
  });
  var nb_desagregated = desagregate_nodes.length;
  var current_y = data.v_space / 2;
  var delta_y = data.v_space / (nb_desagregated - 1);
  desagregate_nodes.forEach(function (n) {
    if (n.x === undefined || n.x === 0 && n.y === 0) {
      n.x = data.nodes[idParent].x;
      n.y = data.nodes[idParent].y - current_y;
    }

    current_y = current_y - delta_y;
  }); // Hides agregated nodes

  data.nodes[idParent].display = false;
  data.nodes[idParent].node_visible = false;
};

exports.desagregation = desagregation;

var agregation = function agregation(data, idParent, cur_dimension) {
  var agregated_node = data.nodes[idParent];
  var desagregate_nodes = Object.values(data.nodes).filter(function (n) {
    return n.dimensions[cur_dimension] && n.dimensions[cur_dimension].parent_name === agregated_node.idNode;
  }); // show agregated node

  agregated_node.display = true;
  agregated_node.node_visible = true;
  var mean_x = 0;
  var mean_y = 0;
  desagregate_nodes.forEach(function (n) {
    data.nodes[n.idNode].display = false;
    data.nodes[n.idNode].node_visible = false;

    if (n.x) {
      mean_x += n.x;
      mean_y += n.y;
    }
  });
  mean_x = mean_x / desagregate_nodes.length;
  mean_y = mean_y / desagregate_nodes.length;

  if (agregated_node.x === undefined || agregated_node.x === 0 && agregated_node.y === 0) {
    agregated_node.x = mean_x;
    agregated_node.y = mean_y;
  }
};

exports.agregation = agregation;
var AgregationModalPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  parent_names: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  dimension_names: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  set_show_agregation: _propTypes.default.func.isRequired,
  show_agregation: _propTypes.default.bool.isRequired,
  is_agregation: _propTypes.default.bool.isRequired
};

var AgregationModal = function AgregationModal(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      parent_names = _ref.parent_names,
      dimension_names = _ref.dimension_names,
      set_show_agregation = _ref.set_show_agregation,
      show_agregation = _ref.show_agregation,
      is_agregation = _ref.is_agregation;
  var idParent = parent_names[0];
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    show: show_agregation,
    onHide: function onHide() {
      return set_show_agregation(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Title, null, is_agregation ? 'Noeuds agrégation' : 'Noeuds desagrégation')), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    onChange: function onChange(evt) {
      return idParent = evt.target.value;
    }
  }, parent_names.map(function (curIdParent, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: curIdParent,
      selected: idParent === curIdParent
    }, data.nodes[curIdParent].name);
  }))))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "secondary",
    onClick: function onClick() {
      if (is_agregation) {
        agregation(data, idParent, dimension_names[parent_names.indexOf(idParent)]);
      } else {
        desagregation(data, idParent, dimension_names[parent_names.indexOf(idParent)]);
      }

      set_data((0, _objectSpread2.default)({}, data));
      set_show_agregation(false);
    }
  }, is_agregation ? 'Agrégation' : 'Désagrégation'), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "secondary",
    onClick: function onClick() {
      return set_show_agregation(false);
    }
  }, "Annuler")));
};

exports.AgregationModal = AgregationModal;